/* design wording for image alt text (SEO): shared by the product scripts */
window.plDesignPhrase = window.plDesignPhrase || function (n) { return ({ 'Daisy Dot': 'Daisy Dot gray with white daisy dot design', 'Green Check': 'Green Check sage green gingham check design', 'Meadow': 'Meadow warm tan floral design', 'Petal': 'Petal pink floral design', 'Polka Dot': 'Polka Dot cream polka dot design', 'Red Check': 'Red Check coral red gingham check design', 'Sprinkles': 'Sprinkles lavender sprinkle design', 'White': 'White solid white design', 'Cosmos': 'Cosmos starry galaxy design', 'Cream': 'Cream solid design', 'Dream': 'Dream pastel sunset design', 'Garden': 'Garden green floral design', 'Navy': 'Navy solid blue design', 'Olive': 'Olive solid green design', 'Seaside Cabana': 'Seaside Cabana blue stripe design', 'Sienna': 'Sienna terracotta red design', 'Sky': 'Sky solid light blue design', 'Sunset Cabana': 'Sunset Cabana orange stripe design' })[n] || (n + ' design'); };
/* Printed Love 3.0 · Everyday Love Pillow product page (Shopify port of the prototype's pillow.js).
   One module per section (init/destroy, shopify:section:load/unload). Design is a real variant; the photo is an Upload-Lift file URL. */
(function () {
  'use strict';

  var CFG = null;
  function cfg() { if (!CFG) { var el = document.querySelector('[data-pl-product-json]'); CFG = el ? JSON.parse(el.textContent) : { variants: [], designs: [] }; } return CFG; }
  // Delivery estimate fallback (used only when no Essential Estimated Delivery app block is on the page): 2-4 days to make + 3-6 days U.S. transit.
  var MAKE = [2, 4], SHIP = [3, 6];
  function addDays(from, n) { return new Date(from.getFullYear(), from.getMonth(), from.getDate() + n); }
  var fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  function eta() { var now = new Date(); return fmt.format(addDays(now, MAKE[0] + SHIP[0])) + ' – ' + fmt.format(addDays(now, MAKE[1] + SHIP[1])); }
  var DESIGNS = [];
  function loadDesigns() { DESIGNS = cfg().designs.map(function (d) { return { name: d.name, tile: d.tile, art: d.art, front: d.front, frontBig: d.frontBig, back: d.back, backBig: d.backBig, sw: '#E8DFD3' }; }); }
  var SWATCH = { Blush: '#F4C1BE', Sand: '#E3D4CF', Sage: '#A4B08C', Lavender: '#B5AFD1', Yellow: '#FEC96D', Confetti: '#F1F0EC', 'Daisy Dot': '#D8DCDB', 'Green Check': '#C4CAB1', Meadow: '#DDCDB5', Petal: '#EDB0B0', 'Polka Dot': '#EFE8DE', 'Red Check': '#DA9984', Sprinkles: '#B6B0CA', White: '#FFFFFF', Cream: '#F9EBDD', Sienna: '#9D4946', Sky: '#B4DCDF', Olive: '#636B56', Navy: '#243D67', 'Seaside Cabana': '#BCC8C7', 'Sunset Cabana': '#E1B39B', Garden: '#7C7755', Dream: '#E7CBA4', Cosmos: '#595B6D' };
  function frontPhoto(d, big) { return big ? d.frontBig : d.front; }
  function backPhoto(d, big) { return big ? d.backBig : d.back; }
  function design(n) { for (var i = 0; i < DESIGNS.length; i++) if (DESIGNS[i].name === n) return DESIGNS[i]; return DESIGNS[0]; }
  function variantFor(n) { var v = cfg().variants; for (var i = 0; i < v.length; i++) if (v[i].design === n) return v[i]; return null; }
  function money(c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : c / 100); }
  function paint(el, d, large) {
    el.style.setProperty('--sw', SWATCH[d.name] || '#E8DFD3');
    el.style.backgroundImage = 'url(' + (large ? d.art : d.tile) + ')';
    el.style.backgroundSize = 'cover'; el.style.backgroundPosition = 'center';
  }

  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  var state = { design: 'Garden', designSet: false, photo: null, photoName: '', photoUrl: null, uploading: false, preview: false, price: 5500 };
  function emit() { document.dispatchEvent(new CustomEvent('pl:change', { detail: state })); }
  function scrollToEl(el, block) { el.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: block || 'center' }); }

  /* shared: paint every illustrated pillow face + portrait from state */
  function paintPillows(scope) {
    var d = design(state.design);
    var back = backPhoto(d, true);
    scope.querySelectorAll('[data-pl-face]').forEach(function (f) {
      var pil = f.closest('.pl-pillow'), photo = !!back && !pil.hasAttribute('data-pl-pillow'); // the gallery's fallback stays drawn
      pil.classList.toggle('is-photo', photo);
      if (photo) { // the photo's white backdrop is darkened against the same gradient as the stage, so the two blend (stage is 100/92 of the face)
        f.style.backgroundImage = 'url(' + back + '), radial-gradient(120% 90% at 20% 10%, #F6F1EA, #E8DFD3 70%)';
        f.style.backgroundSize = 'cover, 108.7% 108.7%'; f.style.backgroundPosition = 'center'; f.style.backgroundRepeat = 'no-repeat'; }
      else { f.style.backgroundRepeat = ''; paint(f, d, true); }
    });
    scope.querySelectorAll('[data-pl-turn-paint]').forEach(function (c) { c.hidden = !state.photo; });
    scope.querySelectorAll('[data-pl-portrait]').forEach(function (p) {
      var img = p.querySelector(':scope > img'), label = p.querySelector('[data-pl-ph-text]') || p.querySelector('span');
      if (state.photo) {
        if (!img) { img = document.createElement('img'); img.alt = ''; p.insertBefore(img, p.firstChild); }
        img.src = state.photo; p.classList.add('has-photo'); label.textContent = 'Rough placement';
      } else { if (img) img.remove(); p.classList.remove('has-photo'); label.textContent = label.hasAttribute('data-pl-ph-text') ? 'Their portrait goes here' : 'Their portrait'; }
    });
  }

  /* ======================================================================
     MODULE: product
     ====================================================================== */
  function initProduct(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var track = root.querySelector('[data-pl-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pl-gallery__thumb'));
    var form = root.querySelector('[data-pl-form]');
    var fileIn = form.querySelector('#pl-photo'); // fallback input, used only when Upload-Lift is not on the page
    var slot = form.querySelector('[data-pl-upload-slot]');
    var variantInput = form.querySelector('[data-pl-variant-id]');
    var current = 0, raf = 0, photoFrom = 'uploaded';

    function go(i, instant) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * current, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === current)); });
    }
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) { current = i; thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); }); }
      });
    }, { passive: true, signal: ac.signal });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }, sig); });
    root.querySelector('[data-pl-prev]').addEventListener('click', function () { go(current - 1); }, sig);
    root.querySelector('[data-pl-next]').addEventListener('click', function () { go(current + 1); }, sig);

    /* swiping forward on the last photo loops back to the first */
    var swipeX = null;
    track.addEventListener('touchstart', function (e) { swipeX = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true, signal: ac.signal });
    track.addEventListener('touchend', function (e) {
      if (swipeX === null) return;
      var dx = e.changedTouches[0].clientX - swipeX; swipeX = null;
      if (dx < -40 && current === slides.length - 1 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 4) go(0);
    }, { passive: true, signal: ac.signal });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    }, sig);

    function setDesign(name, instant, byUser) {
      var d = design(name); state.design = d.name; if (byUser) state.designSet = true;
      var r = form.querySelector('input[name="design"][value="' + d.name + '"]'); if (r) r.checked = true;
      go(0, instant);
      update();
    }
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'design') { PL.memory.set({ design: t.value }); return setDesign(t.value, false, true); }
      if (t.hasAttribute('data-pl-preview')) { state.preview = t.checked; update(); }
    }, sig);

    /* ---- photo: our upload box drives Upload-Lift (its widget is hidden); falls back to a plain file input without the app ---- */
    function err(show, msg) {
      var el = form.querySelector('[data-pl-err="photo"]');
      if (msg) el.textContent = msg; el.hidden = !show;
      el.closest('.pl-field').classList.toggle('is-invalid', show);
      if (show) fileIn.setAttribute('aria-invalid', 'true'); else fileIn.removeAttribute('aria-invalid');
    }
    function lift() { return slot.querySelector('input.filepond--browser'); }
    function showPhoto(src, name, status) {
      state.photo = src; state.photoName = name;
      form.querySelector('[data-pl-thumb]').src = src;
      form.querySelector('[data-pl-file]').textContent = name;
      form.querySelector('[data-pl-upload-ok]').textContent = status || 'Photo added';
      form.querySelector('[data-pl-upload-empty]').hidden = true;
      form.querySelector('[data-pl-upload-done]').hidden = false;
      err(false);
    }
    function clearPhoto() {
      state.photo = null; state.photoName = ''; state.photoUrl = null; state.uploading = false; state.pendingAdd = false;
      form.querySelector('[data-pl-upload-empty]').hidden = false;
      form.querySelector('[data-pl-upload-done]').hidden = true;
      PL.memory.set({ photo: null, photoName: null, photoFrom: null });
      var carried = form.querySelector('[data-pl-carried]'); if (carried) carried.remove();
      update();
    }
    function openPicker() { var f = lift(); (f || fileIn).click(); }
    form.addEventListener('click', function (e) { // "Choose a photo" and "Change" go to Upload-Lift's input when it is there
      var lab = e.target.closest('label[for="pl-photo"]'); if (!lab || !lift()) return;
      e.preventDefault(); openPicker();
    }, sig);
    function onPicked(file) {
      if (!file) return;
      if (!/^image\//.test(file.type) && !/\.(heic|heif)$/i.test(file.name)) { err(true, "That file isn't a photo. Try a JPG, PNG or HEIC from your camera roll."); return false; }
      if (state.localUrl) URL.revokeObjectURL(state.localUrl);
      state.localUrl = URL.createObjectURL(file);
      photoFrom = 'uploaded'; state.photoUrl = null; state.uploading = !!lift();
      showPhoto(state.localUrl, file.name, state.uploading ? 'Uploading…' : 'Photo added');
      var carried = form.querySelector('[data-pl-carried]'); if (carried) carried.remove();
      update();
      return true;
    }
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; if (!onPicked(f)) fileIn.value = ''; }, sig);
    slot.addEventListener('change', function (e) { if (e.target.matches('input.filepond--browser')) { var f = e.target.files && e.target.files[0]; onPicked(f); } }, sig);
    window.addEventListener('upload:added', function (e) {
      var f = e.detail; if (!f || !f.url || (f.meta && f.meta.variant === 'thumbnail')) return;
      state.photoUrl = f.url; state.uploading = false; photoFrom = 'uploaded'; if (state.pendingAdd) { state.pendingAdd = false; form.requestSubmit(); }
      if (!state.photo) showPhoto(f.url, f.name || 'Your photo'); else form.querySelector('[data-pl-upload-ok]').textContent = 'Photo added';
      PL.memory.keepPhoto(f.url, f.name || 'Your photo'); // carried to the other products by its file URL
      err(false); update();
    }, sig);
    window.addEventListener('upload:removed', function () { if (!state.uploading) clearPhoto(); }, sig);
    /* a photo they added on another product: reuse its file URL, no second upload */
    function useCarried(c) {
      photoFrom = 'reused'; state.photoUrl = c.src; state.uploading = false;
      showPhoto(c.src, c.name);
      PL.memory.carriedNote(fileIn.closest('.pl-field'), c.from);
    }

    function nextStep() {
      if (!state.photo) return { key: 'photo', label: 'Add your photo' };
      return { key: 'cart', label: 'Add to cart · ' + money(state.price) };
    }
    document.addEventListener('click', function (e) {
      var st = e.target.closest('[data-pl-strip]'); if (!st) return;
      e.preventDefault();
      // back up to the main personalization box at the top of the page
      scrollToEl(document.querySelector('#pl-buy [data-pl-form]') || document.querySelector('#pl-buy'), 'start');
    }, sig);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pl-nextstep]'); if (!a) return;
      e.preventDefault();
      var n = nextStep();
      if (n.key === 'cart') { form.requestSubmit(); return; }
      if (n.key === 'photo') { openPicker(); return; }
      var t = form.querySelector('.pl-block--design'); scrollToEl(t, 'center');
      var chosen = t.querySelector('input:checked'); if (chosen) chosen.focus({ preventScroll: true });
      t.classList.remove('is-next'); void t.offsetWidth; t.classList.add('is-next');
    }, sig);
    function update() {
      var d = design(state.design), v = variantFor(d.name);
      if (v) { state.price = v.price; state.compare = v.compare || 0; variantInput.value = v.id; try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {} }
      var ns = nextStep();
      document.querySelectorAll('[data-pl-nextstep-label]').forEach(function (l) { l.textContent = ns.label; });
      document.querySelectorAll('[data-pl-nextstep]').forEach(function (b) { b.classList.toggle('is-cart', ns.key === 'cart'); b.classList.toggle('is-photo', ns.key === 'photo'); });
      document.querySelectorAll('[data-pl-strip-label]').forEach(function (l) { l.textContent = (state.photo || state.designSet) ? 'Finish your pillow' : 'Create your pillow'; });
      document.querySelectorAll('[data-pl-pick-name]').forEach(function (l) { l.textContent = state.design; });
      var etaEl = root.querySelector('[data-pl-eta]'); if (etaEl) etaEl.textContent = eta();
      root.querySelector('[data-pl-design-name]').textContent = d.name;
      var fr = frontPhoto(d), fi = root.querySelector('[data-pl-front]');
      if (fi.getAttribute('src') !== fr) { fi.src = fr; fi.srcset = fr + ' 720w, ' + frontPhoto(d, true) + ' 1400w'; fi.alt = 'Everyday Love Pillow ' + d.name + ' Printed Love'; }
      root.querySelector('[data-pl-front-thumb]').src = fr;
      root.querySelector('[data-pl-summary-text]').textContent = d.name + ' · 18 × 18 in';
      var st = root.querySelector('[data-pl-summary-thumb]');
      if (state.photo) { st.style.backgroundImage = 'url(' + state.photo + ')'; st.style.backgroundSize = 'cover'; } else paint(st, d);
      var leadLi = root.querySelector('.pl-gallery__slide.is-lead');
      if (leadLi) { if (state.photo) leadLi.setAttribute('data-pl-live', ''); else leadLi.removeAttribute('data-pl-live'); } // Charlie's pillow until a photo is added, then their live preview
      paintPillows(root);
      var priceTxt = money(state.price);
      var wasEl = root.querySelector('[data-pl-was]');
      if (wasEl) { wasEl.hidden = !(state.compare > state.price); if (!wasEl.hidden) root.querySelector('[data-pl-was-val]').textContent = money(state.compare); }
      root.querySelectorAll('[data-pl-price], [data-pl-atc-price]').forEach(function (p) { p.textContent = priceTxt; });
      var sticky = document.querySelector('[data-pl-sticky-text]'); if (sticky) sticky.textContent = d.name + ' · 18 × 18 in · ' + priceTxt;
      emit();
    }

    /* The main Add to cart button goes through our own submit handler, the same way the sticky bar and the "Next" cards do.
       Upload-Lift otherwise blocks the click when the photo came from another product (no upload on this page) and says nothing. */
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-pl-atc]'); if (!b || !form.contains(b)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      form.requestSubmit();
    }, { capture: true, signal: ac.signal });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!state.photo) { err(true, 'Add a photo of your pet to continue.'); scrollToEl(fileIn.closest('.pl-field')); fileIn.focus({ preventScroll: true }); return; }
      if (state.uploading) { state.pendingAdd = true; err(true, 'Your photo is still uploading. One moment.'); return; }
      if (!state.photoUrl) { err(true, "We couldn't save your photo. Please choose it again."); return; }
      var v = variantFor(state.design); if (!v) return;
      var fd = new FormData(form);
      fd.set('id', v.id); fd.set('quantity', '1');
      if (!fd.get('properties[Pet Photo]')) fd.set('properties[Pet Photo]', state.photoUrl); // a reused photo has no widget field
      fd.set('properties[_photo_from]', photoFrom); fd.set('properties[_set_id]', PL.setId());
      if (!state.preview) fd.delete('properties[Design preview]');
      fd.delete('properties[Pet Name]'); // the pillow has no name field (Upload-Lift's shared Pet Name field is not used here)
      var btn = form.querySelector('[data-pl-atc]'); btn.disabled = true;
      window.PLCart.addForm(fd).catch(function (er) { err(true, er.message || 'Something went wrong. Please try again.'); }).then(function () { btn.disabled = false; });
    }, sig);
    document.addEventListener('pl:pick-photo', openPicker, sig);
    document.addEventListener('pl:set-design', function (e) { PL.memory.set({ design: e.detail }); setDesign(e.detail, false, true); }, sig);

    /* sticky bar (phones), position check so jumps can't skip it */
    var bar = document.querySelector('[data-pl-sticky]'), atc = form.querySelector('[data-pl-atc]'), closeSec = document.querySelector('[data-pl-site="set"]'), barRaf = 0;
    function syncBar() {
      barRaf = 0;
      var passed = atc.getBoundingClientRect().bottom < 0;
      var c = closeSec ? closeSec.getBoundingClientRect() : null;
      var on = passed && !(c && c.top < innerHeight && c.bottom > 0) && innerWidth < 990;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on));
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.documentElement.classList.toggle('pl-sticky-on', on);
    }
    function queueBar() { if (!barRaf) barRaf = requestAnimationFrame(syncBar); }
    addEventListener('scroll', queueBar, { passive: true, signal: ac.signal });
    addEventListener('resize', queueBar, sig);
    bar.querySelector('[data-pl-sticky-btn]').addEventListener('click', function () { form.requestSubmit(); }, sig);
    syncBar();

    var sd = PL.memory.startDesign(); if (sd) { state.design = sd; state.designSet = true; }
    var carried = !state.photo && PL.memory.carriedPhoto(); if (carried) useCarried(carried);
    setDesign(state.design, true);

    /* Warm the cache for every design's front and back photo while the page is idle, so a swatch swaps the pillow instantly. */
    function preloadDesigns() {
      var q = [], fi = root.querySelector('[data-pl-front]');
      DESIGNS.forEach(function (d) {
        if (d.front) q.push({ src: d.front, srcset: d.front + ' 720w, ' + (d.frontBig || d.front) + ' 1400w' });
        if (d.back) q.push({ src: d.back });
      });
      var i = 0;
      (function next() {
        if (i >= q.length) return;
        var it = q[i++], im = new Image();
        if (it.srcset) { im.sizes = (fi && fi.sizes) || '100vw'; im.srcset = it.srcset; }
        im.src = it.src;
        setTimeout(next, 90);
      })();
    }
    if ('requestIdleCallback' in window) requestIdleCallback(preloadDesigns, { timeout: 2500 }); else setTimeout(preloadDesigns, 1500);
    return function () { ac.abort(); cancelAnimationFrame(raf); cancelAnimationFrame(barRaf); bar.classList.remove('is-on'); document.documentElement.classList.remove('pl-sticky-on'); };
  }

  /* ======================================================================
     MODULE: turn (signature) — front shows their portrait, back doesn't
     ====================================================================== */
  function initTurn(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var flip = root.querySelector('[data-pl-flip]'), btn = root.querySelector('[data-pl-turn]');
    var chg = root.querySelector('[data-pl-lead-change]');
    if (chg) chg.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:pick-photo')); }, sig);
    var live = root.querySelector('[data-pl-turn-live]') || { textContent: '' }, first = true;
    function setBack(back) {
      flip.classList.toggle('is-back', back);
      root.classList.toggle('pl-flip-back', back); // swaps the visible label/status without changing their size
      if (btn) { btn.setAttribute('aria-pressed', String(back)); btn.setAttribute('aria-label', back ? 'Show the front' : 'Turn it over'); }
      if (!first) live.textContent = back ? 'Showing the back: same design, no portrait' : 'Showing the front';
      first = false;
    }
    if (btn) btn.addEventListener('click', function () { setBack(!flip.classList.contains('is-back')); }, sig);
    // same swatch rail as the blanket's "Which one feels like them?": tapping also sets the buy box
    var rail = root.querySelector('[data-pl-turn-rail]'); if (rail) rail.innerHTML = '';
    var looks = !rail ? [] : DESIGNS.map(function (d) {
      var li = document.createElement('li'), b = document.createElement('button');
      b.type = 'button'; b.className = 'pl-look'; b.setAttribute('aria-pressed', 'false'); b.dataset.design = d.name;
      var tile = document.createElement('span'); tile.className = 'pl-look__tile'; paint(tile, d);
      var label = document.createElement('span'); label.textContent = d.name;
      b.appendChild(tile); b.appendChild(label); li.appendChild(b); rail.appendChild(li);
      b.addEventListener('click', function () { setBack(false); document.dispatchEvent(new CustomEvent('pl:set-design', { detail: d.name })); }, sig);
      return b;
    });
    var pick = root.querySelector('[data-pl-turn-pick]') || { hidden: false, addEventListener: function () {} };
    pick.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:pick-photo')); }, sig);
    function onState() {
      paintPillows(root); var tdn = root.querySelector('[data-pl-turn-design]'); if (tdn) tdn.textContent = state.design;
      var tnote = root.querySelector('[data-pl-turn-note]'); if (tnote) tnote.textContent = backPhoto(design(state.design)) ? 'Your pet\'s painted portrait goes on the front. Our design team prepares it after you order.' : 'Drawn preview of this design. Your pet\'s painted portrait goes on the front.';
      looks.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.design === state.design)); });
      pick.hidden = !!state.photo;
      if (chg) chg.hidden = !state.photo;
    }
    document.addEventListener('pl:change', onState, sig);
    onState(); setBack(false);
    return function () { ac.abort(); };
  }

  /* ---------------- registry + Shopify editor lifecycle ---------------- */
  function initProof(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    function set(ba, pct) {
      pct = Math.max(0, Math.min(100, Math.round(pct)));
      ba.style.setProperty('--pos', pct + '%');
      var h = ba.querySelector('.pl-ba__handle');
      h.setAttribute('aria-valuenow', pct);
      h.setAttribute('aria-valuetext', pct <= 5 ? 'All pillow' : pct >= 95 ? 'All photo' : Math.round(100 - pct) + '% pillow');
    }
    root.querySelectorAll('[data-pl-ba]').forEach(function (ba) {
      var dragging = false, startX = 0, startY = 0, decided = false;
      function fromEvent(e) { var r = ba.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
      ba.addEventListener('pointerdown', function (e) {
        dragging = true; decided = false; startX = e.clientX; startY = e.clientY;
        if (e.pointerType === 'mouse') { decided = true; ba.classList.add('is-dragging'); set(ba, fromEvent(e)); }
        try { ba.setPointerCapture(e.pointerId); } catch (err) {}
      }, sig);
      ba.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { dragging = false; return; } // a vertical swipe: let the page scroll
          decided = true; ba.classList.add('is-dragging');
        }
        set(ba, fromEvent(e));
      }, sig);
      function end(e) {
        if (dragging && !decided && e && e.type === 'pointerup') set(ba, fromEvent(e)); // a tap jumps the divider
        dragging = false; ba.classList.remove('is-dragging');
      }
      ba.addEventListener('pointerup', end, sig);
      ba.addEventListener('pointercancel', end, sig);
      ba.querySelector('.pl-ba__handle').addEventListener('keydown', function (e) {
        var now = +this.getAttribute('aria-valuenow'), step = { ArrowLeft: -5, ArrowDown: -5, ArrowRight: 5, ArrowUp: 5, PageDown: -20, PageUp: 20 }[e.key];
        if (e.key === 'Home') { e.preventDefault(); return set(ba, 0); }
        if (e.key === 'End') { e.preventDefault(); return set(ba, 100); }
        if (step) { e.preventDefault(); set(ba, now + step); }
      }, sig);
    });
    return function destroy() { ac.abort(); };
  }

  var MODULES = { turn: initTurn, proof: initProof, product: initProduct }; // "Better together" is shared (shared/site.js) // header/footer/cart: shared/site.js
  var ORDER = ['turn', 'proof', 'product']; // listeners mount before product emits
  var live = new Map();
  function mount(el) { var fn = MODULES[el.getAttribute('data-pl-section')]; if (fn && !live.has(el)) live.set(el, fn(el)); }
  function unmount(el) { var d = live.get(el); if (d) { d(); live.delete(el); } }
  function scan(scope) {
    var els = [];
    if (scope.matches && scope.matches('[data-pl-section]')) els.push(scope);
    scope.querySelectorAll('[data-pl-section]').forEach(function (el) { els.push(el); });
    els.sort(function (a, b) { return ORDER.indexOf(a.getAttribute('data-pl-section')) - ORDER.indexOf(b.getAttribute('data-pl-section')); });
    els.forEach(mount);
  }
  document.addEventListener('shopify:section:load', function (e) { loadDesigns(); scan(e.target); emit(); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-pl-section]').forEach(unmount);
    if (e.target.matches('[data-pl-section]')) unmount(e.target);
  });
  loadDesigns(); (cfg().designs.length) && scan(document);
  addEventListener('pagehide', function () { if (state.localUrl) URL.revokeObjectURL(state.localUrl); });
})();
